import React, { useCallback, useEffect, useRef, useState } from 'react'
import { CRow, CCol, CCard, CCardBody } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilImage } from '@coreui/icons'
import AdsManagerService from 'src/service/AdsManagerService'
import GamePromoTable from './GamePromoTable'
import DisplayOrder from './DisplayOrder'

// Game-level promo cards: the hub owns the records, this game only turns them on and off
// and decides the order they appear in.
const GamePromoCardsPanel = ({ onTotalChange }) => {
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(false)
  const [refreshDisplayOrder, setRefreshDisplayOrder] = useState(false)
  const [activePage, setActivePage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [columnFilter, setColumnFilter] = useState({})

  const onTotalChangeRef = useRef(onTotalChange)
  useEffect(() => {
    onTotalChangeRef.current = onTotalChange
  }, [onTotalChange])

  const fetchUsers = useCallback(async () => {
    setLoading(true)
    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()
    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })

    try {
      const result = await AdsManagerService.gameAdsListing(
        offset,
        itemsPerPage,
        activePage,
        params,
      )
      setUsers(result.data)
      onTotalChangeRef.current?.(result.data?.total)
      setRefreshDisplayOrder((prev) => !prev)
    } catch (error) {
      console.error('Error fetching promo cards:', error)
    } finally {
      setLoading(false)
    }
  }, [activePage, itemsPerPage, columnFilter])

  useEffect(() => {
    fetchUsers()
  }, [fetchUsers])

  return (
    <>
      <CRow className="g-3 mb-3">
        <CCol sm={6} lg={4}>
          <CCard className="h-100">
            <CCardBody className="d-flex justify-content-between align-items-center">
              <div>
                <div className="text-medium-emphasis small">Total Promo Cards</div>
                <div className="fs-4 fw-semibold">{users?.total ?? 0}</div>
              </div>
              <div
                className="d-flex align-items-center justify-content-center rounded-circle bg-primary-subtle text-primary"
                style={{ width: 42, height: 42 }}
              >
                <CIcon icon={cilImage} size="lg" />
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <CCard className="mb-3">
        <CCardBody>
          <GamePromoTable
            users={users}
            fetchUsers={fetchUsers}
            setActivePage={setActivePage}
            setItemsPerPage={setItemsPerPage}
            setColumnFilter={setColumnFilter}
            itemsPerPage={itemsPerPage}
            activePage={activePage}
            loading={loading}
          />
        </CCardBody>
      </CCard>

      <CCard>
        <CCardBody>
          <div className="mb-3">
            <h5 className="mb-1">Display Order</h5>
            <div className="text-medium-emphasis small">
              Drag a row to change the order promo cards appear in for this game.
            </div>
          </div>
          <DisplayOrder refreshDisplayOrder={refreshDisplayOrder} />
        </CCardBody>
      </CCard>
    </>
  )
}

export default GamePromoCardsPanel
